import { api } from './api-client';
import { toQueryString } from './query';
import { ApiResponse, Customer, PaginatedResponse, PaginationQuery } from '../types/api';

export type CustomerInput = Omit<Customer, 'id' | 'active'>;
export interface CustomerQuery extends PaginationQuery { active?: boolean; }

export async function listCustomers(query: CustomerQuery = {}) {
  const response = await api.get<PaginatedResponse<Customer>>(`/customers${toQueryString(query)}`);
  return response.data;
}
export async function createCustomer(input: CustomerInput) {
  const response = await api.post<ApiResponse<Customer>>('/customers', input);
  return response.data.data;
}
export async function getCustomer(id: number) {
  const response = await api.get<ApiResponse<Customer>>(`/customers/${id}`);
  return response.data.data;
}
export async function updateCustomer(id: number, input: Partial<CustomerInput>) {
  const response = await api.patch<ApiResponse<Customer>>(`/customers/${id}`, input);
  return response.data.data;
}
export async function updateCustomerStatus(id: number, active: boolean) {
  const response = await api.patch<ApiResponse<Customer>>(`/customers/${id}/status`, { active });
  return response.data.data;
}
